import CustomSegment from '@/components/CustomSegment';
import { useSegment } from '@/hooks/useSegment';
import DashboardLayout from '@/layouts/DashboardLayout';
import type { SegmentedType } from '@/types/global.types';
import Summary from './Summary';

type SegmentType = 'summary' | 'organization' | 'policies' | 'role-permission';

const ControlPanelDashboard = () => {
  const { segment, setSegment } = useSegment<SegmentType>(
    'control-panel-dashboard',
    'summary',
    false,
  );
  const SEGMENT_CONFIG: SegmentedType<SegmentType>[] = [
    {
      value: 'summary',
      label: 'Summary',
      view: <Summary />,
    },
  ];
  const currentSegment = SEGMENT_CONFIG.find((s) => s.value === segment);

  return (
    <DashboardLayout title="Control Panel">
      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />
      <div className="mt-5">{currentSegment?.view}</div>
    </DashboardLayout>
  );
};

export default ControlPanelDashboard;
